export default {
  SET_SOFTPHONE(state, softPhone) {
    state.softPhone = softPhone;
  },
  SET_STATUS(state, status) {
    state.status = status;
  },
  SET_KEEP_CALLING(state, keepCalling) {
    state.keepCalling = keepCalling;
  },
  SET_RECONNECTING(state, reconnecting) {
    state.reconnecting = reconnecting;
  },
  SET_NO_CALLS(state, noCalls) {
    state.noCalls = noCalls;
  },
  SET_DISCONNECT_REASON(state, disconnectReason) {
    state.disconnectReason = disconnectReason;
  },
  SET_RETRY_CONNECTION(state, retryConnection) {
    state.retryConnection = retryConnection;
  },
  SET_DISCONNECTION_TIMEOUT(state, disconnectionTimeout) {
    if (state.disconnectionTimeout) {
      clearTimeout(state.disconnectionTimeout);
    }
    state.disconnectionTimeout = disconnectionTimeout;
  },
  SET_CURRENT_CALL(state, currentCall) {
    state.currentCall = currentCall;
  },
  SET_IS_CAMPAIGN_TRANSFER(state, campaignTransfer) {
    state.isCampaignTransfer = campaignTransfer;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_CALL_LIST_ID(state, callListId) {
    state.callListId = callListId;
  },
  SET_ROOM(state, room) {
    state.room = room;
  },
  SET_AUDIO_TRACK(state, audioTrack) {
    state.audioTrack = audioTrack;
  },
};



// WEBPACK FOOTER //
// ./src/store/dialer_v2/mutations.js